import styled from 'styled-components';
import FooterLogo from '@/atoms/FooterLogo';
import FooterDescription from '@/atoms/FooterDescription';
import { mediaQuery } from '@/styles/media';

const Wrapper = styled.div`
  display: flex;
  align-items: center;

  ${mediaQuery.sp} {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const DescriptionWrapper = styled.div`
  margin-left: 30px;

  ${mediaQuery.sp} {
    margin: 11px 0 0;
  }
`;

const FooterHeading: React.FC = () => (
  <Wrapper>
    <FooterLogo />
    <DescriptionWrapper>
      <FooterDescription />
    </DescriptionWrapper>
  </Wrapper>
);

export default FooterHeading;
